var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSleepStyle2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.455,
    height: 94.869,
    viewBox: "0 0 33.455 94.869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_3262",
    "data-name": "Group 3262",
    transform: "translate(0 0.001)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6980",
    "data-name": "Path 6980",
    d: "M163.4,407.718l-.429,5.431,13.148-.143-.572-6.717Z",
    transform: "translate(-149.132 -371.8)",
    fill: "#ff9976"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6981",
    "data-name": "Path 6981",
    d: "M232.081,919.828l-3.651-2.379s.269,9.44-.279,9.8a5.063,5.063,0,0,0-1.4,1.338,1,1,0,0,0,.108,1.342l5.629,4.429c.318.235.82-.125.772-.554a22.177,22.177,0,0,0-1.224-2.77,9.732,9.732,0,0,0-.845-1.681c-.253-.393.89-9.528.89-9.528",
    transform: "translate(-207.315 -839.568)",
    fill: "#ff9976"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6982",
    "data-name": "Path 6982",
    d: "M139.088,917.608l3.653-2.376s-.278,9.439.27,9.8a5.063,5.063,0,0,1,1.4,1.34,1,1,0,0,1-.109,1.342l-5.633,4.424c-.318.235-.82-.126-.772-.555a22.172,22.172,0,0,1,1.226-2.769,9.727,9.727,0,0,1,.847-1.68c.253-.393-.881-9.529-.881-9.529",
    transform: "translate(-126.187 -837.539)",
    fill: "#ff9976"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6983",
    "data-name": "Path 6983",
    d: "M127.411,472.966c-2.027-.035-3.139,16.366-3.259,20.56s.241,21.779,2.294,22.862,4.708-.812,4.708-.812l1.569-22.862s.483,21.78,1.207,22.591,3.622,3.382,4.95.541,2.777-19.75,3.018-24.079-.41-18.948-1.207-18.8c-10.06,1.851-12.072.021-13.279,0",
    transform: "translate(-113.594 -432.816)",
    fill: "#6aa1b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6984",
    "data-name": "Path 6984",
    d: "M94.526,30.151l-1.578-.22a104.024,104.024,0,0,0-21.469-.749,1.772,1.772,0,0,1-1.863-2.093l.3-1.622a38.031,38.031,0,0,0,.323-11.925h0a1.772,1.772,0,0,1,2.017-1.983l.28.042a104.023,104.023,0,0,0,21.415.952l1.3-.077A1.772,1.772,0,0,1,97.1,14.589l-.2,1.037a38.033,38.033,0,0,0-.451,11.835l.086.726a1.772,1.772,0,0,1-2,1.964",
    transform: "translate(-63.678 -10.563)",
    fill: "#ffe0b4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6985",
    "data-name": "Path 6985",
    d: "M111.921,485.808c-.183.221-.936-1.271-.936-1.271s.684,2.926.735,3.465-1.263-.424-1.19-.363c-.244.295-.92-.389-.933-.524-.587.259-.663-.549-1.141-.572-.564-.948-.4-2.861-.3-3.674h-.012a15.224,15.224,0,0,0-.063-3.736,28.3,28.3,0,0,1,3.021-.525l-.108,3.061a2.993,2.993,0,0,0,.386,1.544,5.139,5.139,0,0,1,.541,2.594",
    transform: "translate(-98.882 -437.98)",
    fill: "#ff9976"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6986",
    "data-name": "Path 6986",
    d: "M334.727,475.853c.175.228.982-1.236.982-1.236s-.792,2.9-.862,3.435,1.278-.378,1.2-.319c.233.3.934-.355.952-.489.577.281.683-.524,1.162-.529.6-.926.507-2.844.436-3.661h.012a15.231,15.231,0,0,1,.2-3.731,28.263,28.263,0,0,0-3-.636l0,3.063a2.994,2.994,0,0,1-.443,1.529,5.14,5.14,0,0,0-.637,2.573",
    transform: "translate(-306.282 -428.902)",
    fill: "#ff9976"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6987",
    "data-name": "Path 6987",
    d: "M101.451,156S94.05,157.62,93,159.31s-4.551,13.666-3.7,20.6a33.464,33.464,0,0,0,.553,3.405,1.518,1.518,0,0,0,1.306,1.163c1.167.134,2.995.216,3.212-.544.322-1.127.322-12.216.322-12.216s.322,8.065.644,9.255c.357,1.321,13.626,1.462,13.843-.258.242-1.915.4-9.014.4-9.014s0,10.882.885,11.445,3.622,1.029,4.185.466-.563-20.442-3.541-24.064c-1.564-1.9-8.939-4.12-9.661-3.549",
    transform: "translate(-81.601 -142.677)",
    fill: "#6aa1b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6988",
    "data-name": "Path 6988",
    d: "M23.669,10.838S29.3,7.917,25.681,2.776,17.3.812,13.435,3.013,6.308.343,3.5,2.318s-6.231,10.51-.01,11.9S11,11.72,13.709,12.087s3.875,2.468,6.141,1.244a26.714,26.714,0,0,0,3.819-2.493",
    transform: "translate(0 -0.005)",
    fill: "#221e3f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6989",
    "data-name": "Path 6989",
    d: "M212.06,130.091a8.575,8.575,0,0,1-.274,2.015,2.454,2.454,0,0,0,2.178,3.146,2.931,2.931,0,0,0,1.865-.513c1.636-1.153.924-4.148.924-4.148Z",
    transform: "translate(-193.72 -119.049)",
    fill: "#ff9976"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6990",
    "data-name": "Path 6990",
    d: "M215.273,130.091a8.96,8.96,0,0,1-.072.987,5.852,5.852,0,0,0,4,2.045,7.464,7.464,0,0,0,.816-.009,6.582,6.582,0,0,0-.05-2.523Z",
    transform: "translate(-196.933 -119.049)",
    fill: "#ef8062"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6991",
    "data-name": "Path 6991",
    d: "M203.88,58.194a2.218,2.218,0,0,0,.278.68c.552.882,2.287,3.131,5.082,1.986,3.439-1.408,2.736-7.96.5-8.659-2.575-.8-7.081.673-5.859,5.993",
    transform: "translate(-186.385 -47.584)",
    fill: "#ff9976"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4401",
    "data-name": "Rectangle 4401",
    width: 33.455,
    height: 94.869,
    transform: "translate(0 0)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepStyle2);
export default __webpack_public_path__ + "static/media/sleep_style_2.44ee8a302c36371e5afe477ce1959b48.svg";
export { ForwardRef as ReactComponent };